<!--Header of Chatbot-->
<!--<div-->
<!--  class="chat-boat-header position-relative w-100 d-flex flex-row align-items-start py-2"-->
<!--&gt;-->

<!--  <div class="d-flex align-items-center justify-content-center">-->
<!--    <div class="d-flex align-items-center justify-content-start w-100 ">-->
<!--      &lt;!&ndash; <img class="logo d-inline-block" src="assets/imgs/Back Icon.png" /> &ndash;&gt;-->
<!--      <div class="d-flex">-->
<!--        <div style="height: 50px" class="d-flex align-items-center px-2">-->
<!--          <img-->
<!--            height="100%"-->
<!--            class=""-->
<!--            src="assets/imgs/Frame%20368%203.svg"-->
<!--            style="border-radius: 50%;border: 2px solid white"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="d-inline-block d-flex flex-column justify-content-center">-->
<!--          <span class="user-name">-->
<!--            <span style="color: #ffffff;font-weight: bold"> ThingLogixCE</span>-->
<!--            <span style="color:  whitesmoke"> Chatbot </span>-->
<!--          </span>-->
<!--          <span class="py05"></span>-->
<!--          <small-->
<!--            class="d-block small-line description"-->
<!--            style="color: rgb(255, 255, 255, 0.7);font-weight: 300!important;font-size: 11px"-->
<!--          >-->
<!--            Typically replies within a minute-->
<!--          </small>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="spacer"></div>-->


<!--  <div class="float-left pl-3 pr-3">-->
<!--    <img-->
<!--      src="assets/imgs/minimise.png"-->
<!--      (click)="toggleChatBot(0)"-->
<!--      class="p-2 header-image"-->
<!--    />-->
<!--    <img src="assets/imgs/close.png" (click)="toggleChatBot(2)" class="p-2 header-image" />-->
<!--  </div>-->

<!--</div>-->
<div class="chat-boat-header position-relative w-100 d-flex flex-row align-items-start py-3">
  <div class="d-flex align-items-center justify-content-center">
    <div class="d-flex align-items-center justify-content-start w-100 ">
      <div class="d-flex">
        <div class="d-flex bot-icon align-items-center px-3">
          <img src="assets/imgs/ot_icon_noor_full_90x90 2.svg" class="bot-image">
        </div>
        <div class="d-inline-block d-flex flex-column justify-content-center">
                    <span class="user-name">
                      <img src="assets/imgs/NOOR.png">
                    </span>
          <span class="py05"></span>
          <!-- <small class="d-block small-line description">Typically replies within a minute</small> -->
        </div>
      </div>
    </div>
  </div>
  <div class="spacer"></div>
  <div class="float-left pl-3 pr-3 pt-2">
<!--    <img class="p-2 header-image" src="assets/imgs/minimise.png" (click)="toggleChatBot(0)">-->
    <img class="p-2 header-image" src="assets/imgs/close.png" (click)="toggleChatBot(0)">
  </div>
</div>